const translation = {
  'message.join_message': `Hej! Słuchajcie! {name} właśnie dołączył!`,
  'message.channel': `Wiadomość {channel}`,
  'header.join': `Dołącz na Discord!`
}

export default translation



// WEBPACK FOOTER //
// ./src/app/locales/translations/en.ts